<template>
  <div class="fixed top-navbar">
    <div class="flex flex-center bg padd5px" :class="bgColor">
      <slot>
        <van-icon v-if="!isHome" name="arrow-left" class="icon" @click="arrowLeft" />
        <div class="home-logo" v-if="isHome"><img :src="homelogo" /></div>
        <div :class="{'title':1, 'onHome':isHome}">{{ title }}</div>
      </slot>
    </div>
  </div>
</template>
<script>
import homelogo from "@/assets/fastorder.logo.png"
export default {
  props: {
    title: {
      type: String,
      default: 'fastorder.my'
    },
    bgColor: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isHome: true,
      homelogo: homelogo
    }
  },
  created () {
    if (this.$route.name !== 'home') {
      this.isHome = false
    }
    // console.log('============> router-----', this.isHome)
  },
  methods: {
    arrowLeft () {
      console.log('============> arrowLeft', '返回上一面')
      if (this.$route.name !== 'home') {
        window.history.back(-1)
      }
    }
  }
}
</script>
<style lang="less">
@import url('../../assets/css/common.less');
.top-navbar {
  z-index: 1000;
  left: 0;
  right: 0;
  top: 0;
  color: @fff;
  .home-logo{
    width: 20px;
    height: 20px;
    img{
      width: 100%;
    }
  }
  .bg {
    background-color: rgba(0, 0, 0, 0.5);
    .icon {
      padding: 5px 5px;
      background-color: rgba(255, 255, 255, 0.38);
      border-radius: 100%;
      margin-right: 13px;
    }
    .title {
      font-weight: 700;
    }
    .onHome {
      padding: 4px 0;
      width: 100%;
      text-align: center;
    }
  }
}
</style>
